import {
  mainRequests
} from './custom'

/** AWS API Gateway + Lambda зарим интеграцид JSON-ийг body string-ээр давхар ороосон байдаг */
function unwrapApiResponse (payload) {
  let cur = payload
  for (let i = 0; i < 5; i++) {
    if (cur != null && typeof cur === 'object' && typeof cur.body === 'string') {
      try {
        cur = JSON.parse(cur.body)
        continue
      } catch (_) {
        break
      }
    }
    break
  }
  return cur
}

export default {
  createTrackCode (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .putAuth('/updateTrackCode/' + payload.track_code, payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  trackCodeList (selectedComponent, isPaidType, currentPage, pageSize) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth('/getTrackCodes?selected_component=' + selectedComponent + '&isPaidType=' + isPaidType + '&page=' + currentPage + '&limit=' + pageSize)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  // trackCodeSearch (isPaid, selectedComponent, searchQuery, formattedStartDate, formattedEndDate) {
  trackCodeSearch (isPaid, selectedComponent, searchQuery) {
    const sc = Array.isArray(selectedComponent)
      ? selectedComponent.join(',')
      : String(selectedComponent ?? '')
    const q = searchQuery != null ? String(searchQuery) : ''
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(
          '/getTrackCodesSearch?is_paid=' +
            encodeURIComponent(String(isPaid)) +
            '&selected_component=' +
            encodeURIComponent(sc) +
            '&search_query=' +
            encodeURIComponent(q)
        )
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  trackCodeButton (isPaid, selectedComponent) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth('/getTrackCodesAppButton?is_paid=' + isPaid + '&progress_code=' + selectedComponent)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  login (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .post('/login', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  searchTrackCodeOlgolt (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(`/serachOlgolt/${payload}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  searchTrackCodeHistory (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(`/serachHistory/${payload}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  calculatePrice (configTypeId, jin, urt, undur, urgun) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/calculatePrice', { config_type_id: configTypeId, jin: jin, urt: urt, undur: undur, urgun: urgun })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getTrackCodesBySamePhone (searchItem, type) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth('/trackCodeAndProgress?search_item=' + searchItem + '&type=' + type)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  updateTrackCode (trackCode, payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .putAuth(`/updateTrackCode/${trackCode}`, payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getTrackCodeCountByUser () {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth('/countTrackCodeByUser')
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  trackCodeHistory (page, limit) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth('/trackCodesCreatedUserHistory?page=' + page + '&limit=' + limit)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  deleteTrackCode (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth(`/trackCodes/${payload}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getTrackCodeById (id) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(`/trackCodesId/${id}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getActiveConfig (data) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(`/config/${data}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  updateIsPayed (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/updateIsPayed', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  createTrackCodesAndProgress (trackCodes, progressCode, ispaid, paidType) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/trackCodesAndProgressFromApp', { track_code: trackCodes, progress_code: progressCode, is_paid: ispaid, paid_type: paidType })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  toHurgelt (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/toHurgeltCheck', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getPhoneFromTrackCodes (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/phoneNumber', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  createAddress (nickName, addressDetail) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/address', { nick_name: nickName, address_detail: addressDetail })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  giveUser (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/giveUser', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  progressChange (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/progressChange', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getCargoProgress () {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth('/cargoProgress')
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getCargoProgressById (data) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(`/cargoProgress/${data}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getCompanies () {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth('/companies')
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  createdCargo (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/cargoProgress', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getDeliveryList (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/deliveryList', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  changeIsReady (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/delivery', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  changeIsPaid (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/isPaid', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getAllWorkers () {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAuth('/workersList')
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  phoneSuggest (payload) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAuth('/phone-suggest', {
          params: { payload }
        })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAllCupon () {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAuth('/cupon')
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getPhones (payload) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .postAuth('/phoneSuggest', payload)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  createTypeCheckTrackCode (payload) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .postAuth('/checkTrackCode', payload)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  calculateCuoponPrice (payload) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .postAuth('/cuponPrice', payload)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  changeDeliveryStatus (payload) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .postAuth('/changeDeliveryStatus', payload)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  createPackage (payload) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .postAuth('/createPackage', payload)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  changeMeasurement (payload) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .postAuth('/changeMeasurement', payload)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deletePackage (payload) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .postAuth('/deletePackage', payload)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getBranches (payload) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .postAuth('/getBranches', payload)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getTrackCodesHistory ({ selectedComponent, page = 1, limit = 10, searchQuery = null } = {}) {
    const normalizedComponent = Array.isArray(selectedComponent) ? selectedComponent.join(',') : selectedComponent
    if (!normalizedComponent || `${normalizedComponent}`.trim() === '') {
      return Promise.reject(new Error('selectedComponent is required'))
    }
    const params = new URLSearchParams()
    params.append('selected_component', `${normalizedComponent}`.trim())
    params.append('page', String(page))
    params.append('limit', String(limit))
    const normalizedSearch = searchQuery !== null && searchQuery !== undefined && `${searchQuery}`.trim() !== '' ? `${searchQuery}`.trim() : 'null'
    params.append('searchQuery', normalizedSearch)
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAuth(`/getTrackCodesHistory?${params.toString()}`)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getTrackCodesApp (selectedComponent, isPaidType, currentPage, pageSize) {
    const sc = Array.isArray(selectedComponent)
      ? selectedComponent.join(',')
      : String(selectedComponent ?? '')
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(
          '/getTrackCodesApp?selected_component=' +
            encodeURIComponent(sc) +
            '&isPaidType=' +
            encodeURIComponent(String(isPaidType)) +
            '&page=' +
            encodeURIComponent(String(currentPage)) +
            '&limit=' +
            encodeURIComponent(String(pageSize))
        )
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  // Costs API
  getCosts (params = {}) {
    return new Promise((resolve, reject) => {
      const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&')
      const url = queryString ? `/costs?${queryString}` : '/costs'
      mainRequests
        .getAuth(url)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getCostTypes () {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth('/costTypes')
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  createCost (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/costs', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  updateCost (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .putAuth(`/costs/${payload.id}`, payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  deleteCost (id) {
    return new Promise((resolve, reject) => {
      mainRequests
        .deleteFunction(`/costs/${id}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getBranchesWeb () {
    return new Promise((resolve, reject) => {
      mainRequests
        .get('/branchesWeb')
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getYuan () {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth('/getYuan')
        .then((res) => resolve(unwrapApiResponse(res)))
        .catch((err) => reject(err))
    })
  },
  postYuan (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/updateYuan', { payload })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  }
}
